import { useEffect } from 'react'

// 添加window类型声明
declare global {
  interface Window {
    binancew3w?: any;
  }
}

// 开发环境调试组件
export function DevConsole() {
  useEffect(() => {
    // 只在开发环境下加载vConsole
    if (true || import.meta.env.DEV) {
      import('vconsole').then(({ default: VConsole }) => {
        const vConsole = new VConsole({
          defaultPlugins: ['system', 'network', 'element', 'storage'],
          theme: 'dark',
          disableLogScrolling: false
        })
        
        // 强制设置vConsole的z-index，确保显示在最前面
        setTimeout(() => {
          const vConsoleElement = document.querySelector('#__vconsole') as HTMLElement
          if (vConsoleElement) {
            vConsoleElement.style.zIndex = '99999'
          }
          
          // 设置按钮位置，避免被币安浏览器UI遮挡
          const vConsoleSwitchElement = document.querySelector('.vc-switch') as HTMLElement
          if (vConsoleSwitchElement) {
            vConsoleSwitchElement.style.zIndex = '99999'
            vConsoleSwitchElement.style.right = '20px'
            vConsoleSwitchElement.style.bottom = '100px' // 避开币安底部UI
          }
        }, 500)
        
        // 添加一些自定义日志
        console.log('🚀 PIN AI TGE DApp Debug Console 已启动')
        console.log('📱 当前环境:', import.meta.env.MODE)
        console.log('🌐 User Agent:', navigator.userAgent)
        console.log('🔗 binancew3w 对象存在:', !!window.binancew3w)
        
        if (window.binancew3w) {
          console.log('🔗 binancew3w 详细信息:', window.binancew3w)
          console.log('🔗 binancew3w keys:', Object.keys(window.binancew3w))
        }
        
        // 清理函数
        return () => {
          vConsole.destroy()
        }
      })
    }
  }, [])

  // 不渲染任何可见内容
  return null
} 